import React from 'react';

interface BarCodeReaderProps extends React.DetailedHTMLProps<
  React.VideoHTMLAttributes<HTMLVideoElement>, HTMLVideoElement> {
  onScan:(text:string) => void
}

export default ({ onScan, ...rest }:BarCodeReaderProps) => {
    async function detect() {
        const mediaStream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: 'environment' }, audio: false,
        });

        const video = document.getElementById('videoCamera');
        video.srcObject = mediaStream;
        await video?.play();

        const barcodeDetector = new BarcodeDetector();

        let lastRead = '';
        const render = async () => {
            const barcodes = await barcodeDetector.detect(video);
            barcodes.map((barcode) => {
                const valueRead = barcode.rawValue;

                if (lastRead !== valueRead) {
                    lastRead = barcodes[0].rawValue;
                    alert(valueRead);
                    onScan(valueRead);
                }
            });
        };

        (function renderLoop() {
            requestAnimationFrame(renderLoop);
            render();
        }());
    }

    detect();

    return (
        <video id="videoCamera" autoPlay {...rest} />
    );
};
